import React from 'react';
import { ArrowRight } from 'lucide-react';
import { services } from '../data/mock';

const Services = ({ onBook }) => {
  return (
    <section id="services" className="relative bg-[#F4EFE7] py-28 lg:py-36">
      <div className="vertical-divider hidden lg:block"></div>

      <div className="max-w-[1400px] mx-auto px-8 lg:px-12 relative">
        <div className="max-w-xl">
          <p className="text-[11px] tracking-[0.3em] text-[#8B7FB8] font-medium mb-6">
            02 &nbsp;—&nbsp; SERVICES
          </p>
          <h2 className="font-serif text-5xl lg:text-6xl leading-[1.05] text-[#1E1B18] mb-8">
            Choose your treatment
          </h2>
          <p className="text-[15px] text-[#1E1B18]/70 leading-relaxed max-w-md">
            Registered Massage Therapy offered in 30 and 60 minute sessions. Book online in under a minute.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-20">
          {services.map((service, idx) => (
            <div
              key={service.id}
              className="group bg-[#FBF7F0] border border-[#1E1B18]/8 rounded-sm overflow-hidden hover:shadow-xl transition-all duration-500 flex flex-col"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7 flex flex-col flex-1">
                <h3 className="font-serif text-2xl text-[#1E1B18] mb-3">{service.name}</h3>
                <p className="text-[14px] text-[#1E1B18]/70 leading-relaxed mb-6 flex-1">
                  {service.description}
                </p>

                <div className="grid grid-cols-2 gap-x-5 gap-y-2 mb-6 text-[13px]">
                  {service.prices.map((p) => (
                    <div key={p.duration} className="flex items-baseline justify-between border-b border-[#1E1B18]/8 pb-1.5">
                      <span className="text-[#1E1B18]/60">{p.duration}</span>
                      <span className="text-[#1E1B18] font-medium">{p.price}</span>
                    </div>
                  ))}
                </div>

                <button
                  onClick={() => onBook && onBook(service.id)}
                  className="w-full bg-[#B9A9D6] hover:bg-[#A896C9] text-[#1E1B18] py-3 rounded-full text-[13px] font-medium flex items-center justify-center gap-2 transition-all group/btn"
                >
                  Book
                  <ArrowRight size={14} className="group-hover/btn:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
